/*
 * @Author: WLL
 * @Date: 2020-04-29 14:06:28
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-01 00:04:02
 * @Description: 分析师预测页面接口
 */
import http from "@/utils/http";

export default {
  async getAnalystList(params) {
    return await http.post("predict/analyst/analyst_list", params);
  },
  async getAnalystReport(params) {
    return await http.post("predict/analyst/report", params);
  },
  async getRateLineData(params) {
    return await http.post("predict/analyst/rate_return", {
      pageNo: 1,
      pageSize: null,
      ...params
    });
  },
  async getAnalystStock(params) {
    return await http.post("predict/analyst/recommend_stock", params);
  }
};
